module.exports = "<p>\n  pin works!\n</p>\n\n<app-picture *ngFor=\"let photo of listOfPhotos; let i = index\" [result]=\"photo\"></app-picture>\n"